export default {
  copyingPrize: false,
  copyPrizeFormSubmitted: false,
  createdChallengeId: null,
  error: null
};



// WEBPACK FOOTER //
// ./public/pages/PrizeCopy/initialState.js